import { MainBox, MainList, MainTextBox, MainTop } from "./style";

const Nav3 = ({ t }) => {
  return (
    <MainBox>
      <MainTop>
        <div>{t("Nav-3-1")}</div>
        <span>{t("Nav-3-2")}</span>
      </MainTop>
      <MainTextBox>
        <span>{t("Nav-3-3")}</span>
        <span>
          <span>{t("Nav-3-4")}</span>
          <span>{t("Nav-3-5")}</span>
        </span>
        <MainList>
          <div>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
              alt=""
            />
            <span>{t("Nav-3-6")}</span>
          </div>
          <div>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
              alt=""
            />
            <span>
              <span>{t("Nav-3-7")}</span>
            </span>
          </div>
          <div>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
              alt=""
            />
            <span>{t("Nav-3-8")}</span>
          </div>
        </MainList>
      </MainTextBox>
      <MainTextBox>
        <span>
          <span>{t("Nav-3-9")}</span>
          <span>{t("Nav-3-10")}</span>
        </span>
        <div>
          <span>{t("Nav-3-11")}</span>
        </div>
        <MainList>
          <div>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
              alt=""
            />
            <span>
              <span>{t("Nav-3-12")}</span>
              <span>{t("Nav-3-13")}</span>
            </span>
          </div>
          <div>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
              alt=""
            />
            <span>
              <span>{t("Nav-3-14")}</span>
            </span>
          </div>
          <div>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
              alt=""
            />
            <span>
              {t("Nav-3-15")}
              <div>
                <span>{t("Nav-3-16")}</span>
              </div>
              <div>{t("Nav-3-17")}</div>
            </span>
          </div>
        </MainList>
      </MainTextBox>
    </MainBox>
  );
};

export default Nav3;
